import { render, staticRenderFns } from "./CallEditProject.vue?vue&type=template&id=3335be3c&scoped=true"
import script from "./CallEditProject.vue?vue&type=script&lang=js"
export * from "./CallEditProject.vue?vue&type=script&lang=js"
import style0 from "./CallEditProject.vue?vue&type=style&index=0&id=3335be3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335be3c",
  null
  
)

export default component.exports